export const FetchingAvailableAppointments: React.FC = () => {
  return (
    <div className="p-10 text-[#495B6F] font-normal text-sm leading-6 text-center md:pl-24 min-h-[10rem] md:min-h-[15rem] flex md:justify-center items-center">
      Fetching available appointments
    </div>
  )
}
